"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCheckboxBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_checkbox_constants_1 = require("./bc-checkbox-constants");
var BcCheckboxBehavior = (function (_super) {
    __extends(BcCheckboxBehavior, _super);
    function BcCheckboxBehavior() {
        var _this = _super.call(this) || this;
        _this.isChecked = false;
        return _this;
    }
    BcCheckboxBehavior.setUpAll = function () {
        var checkboxElements = Array.from(document.querySelectorAll("[class^='".concat(bc_checkbox_constants_1.BcCheckboxConstants.CHECKBOX_CLASS, "'] > input[type=").concat(bc_checkbox_constants_1.BcCheckboxConstants.CHECKBOX, "]")));
        return checkboxElements.map(function (element) {
            var bc = new BcCheckboxBehavior();
            bc.setElement(element);
            bc.setUp();
            return bc;
        });
    };
    BcCheckboxBehavior.prototype._setUp = function () {
        this.setAccesibility();
        this.setStates();
        this.setHandlers();
    };
    BcCheckboxBehavior.prototype.elementClick = function (element) {
        this.isChecked = !this.isChecked;
        element.checked = this.isChecked;
        element.setAttribute(bc_checkbox_constants_1.BcCheckboxConstants.ATTR_ARIA_CHECKED, String(this.isChecked));
        if (this.isChecked) {
            element.setAttribute(bc_checkbox_constants_1.BcCheckboxConstants.ATTR_CHECKED, bc_checkbox_constants_1.BcCheckboxConstants.ATTR_CHECKED);
        }
        else {
            element.removeAttribute(bc_checkbox_constants_1.BcCheckboxConstants.ATTR_CHECKED);
        }
    };
    BcCheckboxBehavior.prototype.setStates = function () {
        var element = this.mySelf;
        var isIndeterminate = element.getAttribute(common_constants_1.BcCommonConstants.INDETERMINATED) !== null;
        if (isIndeterminate) {
            element.indeterminate = true;
            element.setAttribute(bc_checkbox_constants_1.BcCheckboxConstants.ATTR_ARIA_CHECKED, bc_checkbox_constants_1.BcCheckboxConstants.MIXED);
        }
        var isDisabled = element.getAttribute(common_constants_1.BcCommonConstants.DISABLED) !== null;
        if (isDisabled) {
            element.parentElement.classList.add(bc_checkbox_constants_1.BcCheckboxConstants.CHECKBOX_CLASS_DISABLED);
        }
    };
    BcCheckboxBehavior.prototype.setAccesibility = function () {
        if (this.mySelf.parentElement != null) {
            var parentId = this.mySelf.parentElement.id;
            if (parentId) {
                this.mySelf.setAttribute(bc_checkbox_constants_1.BcCheckboxConstants.ATTR_ARIA_DESCRIBEDBY, parentId);
                this.mySelf.setAttribute(bc_checkbox_constants_1.BcCheckboxConstants.ATTR_ARIA_LABELLEDBY, parentId);
            }
        }
        this.isChecked = this.mySelf.hasAttribute(bc_checkbox_constants_1.BcCheckboxConstants.ATTR_CHECKED);
        this.mySelf.setAttribute(bc_checkbox_constants_1.BcCheckboxConstants.ATTR_ARIA_CHECKED, String(this.isChecked));
        this.mySelf.setAttribute(common_constants_1.BcCommonConstants.ROLE, bc_checkbox_constants_1.BcCheckboxConstants.CHECKBOX);
        this.mySelf.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, this.mySelf.parentElement.childNodes[0].textContent.trim());
    };
    BcCheckboxBehavior.prototype.setHandlers = function () {
        this.mySelf.addEventListener(bc_checkbox_constants_1.BcCheckboxConstants.EVT_CLICK, this.elementClick.bind(this, this.mySelf));
    };
    return BcCheckboxBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcCheckboxBehavior = BcCheckboxBehavior;
